import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
/**
 * UniverseQuartileChartHighcharts
 *
 * A customized version of the highcharts module for use in the universe quartile chart.
 * `highcharts-more` is what supplies the native `boxplot` series type the universe
 * distribution is drawn with, so it is the one module this chart cannot go without.
 *
 * Note: All universe-quartile-chart code should import Highcharts from this module instead of
 * directly from 'highcharts', and never from the fundamental chart's entry point. That one also
 * registers stock-tools, exporting and a logarithmic-axis extension this chart has no use for;
 * sharing it would tie this bundle -- and Highcharts' global configuration -- to an unrelated chart.
 */
HighchartsMore(Highcharts);
export default Highcharts;
